export default {
  Title : 'Διανομείς | Διανομέας | Διανομείς',
  Button: {
    DeliveryStaff: {
      Add: {
        Title: 'Προσθήκη Διανομέα',
        Color: 'primary',
        Icon : 'add_box'
      },
      Edit: {
        Color: 'grey lighten-0',
        Icon : 'edit'
      },
      Delete: {
        PopUp: {
          Title  : 'Διαγραφή Διανομέα;',
          Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε οριστικά το διανομέα;'
        }
      }
    },
    RemoveOrder: {
      PopUp: {
        Title  : 'Αφαίρεση Παραγγελίας;',
        Content: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε την παραγγελία από τη βάρδια του διανομέα;'
      }
    },
    Shift: {
      Open: {
        Title: 'Άνοιγμα βάρδιας',
        Color: 'green',
        Icon : 'fas fa-plus-circle',
        PopUp: {
          Title : 'Ποσό Έναρξης Βάρδιας',
          Hint  : 'Το ποσό με το οποίο ξεκινάει η βάρδια.',
          Button: 'Άνοιγμα'
        }
      },
      Close: {
        Title: 'Κλείσιμο βάρδιας',
        Color: 'red',
        Icon : 'fas fa-times-circle',
        PopUp: {
          Title                : 'Κλείσιμο Βάρδιας;',
          Content              : 'Είστε σίγουροι ότι θέλετε να κλείσετε τη βάρδια;',
          CompletedCardPayments: 'Παραγγελίες με ολοκληρωμένη πληρωμή κάρτας | Παραγγελία με ολοκληρωμένη πληρωμή κάρτας | Παραγγελίες με ολοκληρωμένη πληρωμή κάρτας',
          PendingCardPayments  : 'Παραγγελίες χωρίς πληρωμή κάρτας | Παραγγελία χωρίς πληρωμή κάρτας | Παραγγελίες χωρίς πληρωμή κάρτας',
          WithoutFiscalDoc     : 'Παραγγελίες χωρίς παραστατικό | Παραγγελία χωρίς παραστατικό | Παραγγελίες χωρίς παραστατικό'
        }
      }
    }
  },

  ListView: {
    NoData: {
      Title   : 'Δημιουργήστε Διανομέα',
      Subtitle: 'Προσθέστε νέο διανομέα',
      Icon    : 'account_circle'
    },
    SelectDeliveryStaff: {
      Title   : 'Επιλέξτε Διανομέα',
      Subtitle: 'Επιλέξτε διανομέα από την λίστα',
      Icon    : 'directions_bike'
    },
    Table: {
      Headers: {
        DateStarted: 'Ημ/νία',
        Swifts     : 'Βάρδιες',
        Orders     : 'Παραγγελίες',
        Total      : 'Σύνολο',
        Actions    : ''
      }
    }
  },

  Common: {
    Orders      : 'Παραγγελίες',
    ShiftsOrders: 'Παραγγελίες βάρδιας: ',
    ShiftStart  : 'Έναρξη βάρδιας',
    ShiftTotal  : 'Σύνολο βάρδιας',
    InfoLabels  : {
      Icon     : 'account_circle',
      Telephone: 'Τηλ.:',
      Email    : 'Email:'
    }
  },

  UserDashboard: {
    Tab: {
      Added: {
        Title : 'ΑΠΟΔΟΧΗ',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'Δεν υπάρχουν παραγγελίες προς αποδοχή',
          Subtitle: ''
        }
      },
      Accepted: {
        Title : 'ΠΑΡΑΛΑΒΗ',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'Δεν υπάρχουν παραγγελίες προς διανομή',
          Subtitle: ''
        }
      },
      Received: {
        Title : 'ΔΙΑΝΟΜΗ',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'Δεν υπάρχουν παραγγελίες προς διανομή',
          Subtitle: ''
        }
      },
      Completed: {
        Title : 'ΟΛΟΚΛΗΡΩΜΕΝΕΣ',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'Δεν υπάρχουν ολοκληρωμένες παραγγελίες',
          Subtitle: ''
        }
      },
      UnPaid: {
        Title : 'ΑΝΕΞΟΦΛΗΤΕΣ',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'Δεν υπάρχουν ανεξόφλητες παραγγελίες',
          Subtitle: ''
        }
      },
      Paid: {
        Title : 'ΕΞΟΦΛΗΜΕΝΕΣ',
        NoData: {
          Icon    : 'shopping_cart',
          Title   : 'Δεν υπάρχουν εξοφλημένες παραγγελίες',
          Subtitle: ''
        }
      }
    },
    Message: {
      Notify: {
        Success: 'Η ειδοποίηση για την παραγγελία #{orderCode} έχει αποσταλεί.'
      }
    },
    Button: {
      Map       : 'Map',
      Directions: 'Οδηγίες',
      Accepted  : 'Αποδοχή',
      Declined  : 'Απόρριψη',
      Received  : 'Παραλαβή',
      Delivered : 'Ολοκλήρωση'
    }
  },

  DeliveryOrderStatus: {
    Added: {
      Label: 'Ανατέθηκε',
      Color: 'grey',
      Icon : 'mdi-account-plus'
    },
    Accepted: {
      Label: 'Αποδεκτή',
      Color: 'blue',
      Icon : 'mdi-account-check'
    },
    Received: {
      Label: 'Σε Διανομή',
      Color: 'purple',
      Icon : 'mdi-progress-clock'
    },
    Delivered: {
      Label: 'Παραδόθηκε',
      Color: 'success',
      Icon : 'mdi-package-variant-closed-check'
    }
  },

  DeliveryUser: {
    Warning : 'Ο χρήστης του διανομέα θα διαγραφεί οριστικά!',
    Settings: {
      Title       : 'Ρυθμίσεις',
      CanOpenShift: {
        Title   : 'Άνοιγμα βάρδιας',
        Subtitle: 'Άνοιγμα βάρδιας διανομέα'
      },
      CanCloseShift: {
        Title   : 'Κλείσιμο βάρδιας',
        Subtitle: 'Κλείσιμο βάρδιας διανομέα'
      },
      CanAddOrder: {
        Title   : 'Ανάθεση παραγγελίας',
        Subtitle: 'Προσθήκη παραγγελίας στην βάρδια'
      },
      CanDeleteOrder: {
        Title   : 'Αφαίρεση παραγγελίας',
        Subtitle: 'Αφαίρεση παραγγελίας απο την βάρδια'
      },
      CanTransactionSale: {
        Title   : 'Χρέωση σε κάρτα',
        Subtitle: 'Χρέωση κάρτας πελάτη και έκδοση απόδειξης'
      },
      CanGenerateDocument: {
        Title   : 'Έκδοση απόδειξης',
        Subtitle: 'Έκδοση φορολογικού παραστατικού (απόδειξης)'
      },
      IsGenerateDocumentRequired: {
        Title   : 'Υποχρεωτική Έκδοση απόδειξης',
        Subtitle: 'Υποχρεωτική Έκδοση φορολογικού παραστατικού (απόδειξης)'
      },
      CanPrintDocument: {
        Title   : 'Εκτύπωση απόδειξης',
        Subtitle: 'Εκτύπωση φορολογικού παραστατικού (απόδειξης)'
      },
      CanTransactionRefund: {
        Title   : 'Επιστροφή σε κάρτα',
        Subtitle: 'Επιστροφή σε κάρτα πελάτη'
      },
      TrackLocation: {
        Title   : 'Παρακολούθηση σε χάρτη',
        Subtitle: 'Παρακολουθήστε τη γεωγραφική θέση του διανομέα σε χάρτη'
      }
    }
  },

  DeliveryStaffInfo: {
    Tab: {
      Details: '@:Common.Misc.Details',
      History: 'Ιστορικό'
    },
    Button: {
      AddOrder: {
        Title: 'Προσθηκη Παραγγελιας',
        Color: 'light-green'
      },
      ViewDailyShift: {
        Title: 'Προβολή βαρδιών ημέρας',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      }
    },
    Result: {
      NoOrders     : 'Δεν υπάρχουν ακόμη παραγγελίες βάρδιας',
      NoOrdersShift: {
        Title   : 'Δεν υπάρχουν παραγγελίες βάρδιας',
        Subtitle: 'Προσθέστε μια νέα παραγγελία',
        Icon    : 'shopping_cart'
      },
      InactiveShift: {
        Icon         : 'directions_bike',
        Title        : 'Μη Ενεργή Βάρδια',
        SubtitleLink : 'Ανοίξτε',
        SubtitleText : 'τη βάρδια διανομέα',
        SubtitleText2: 'Ζητήστε από τον διαχειριστή να ανοίξει τη βάρδια σας'
      }
    }
  },

  PrintDeliveryShift: {
    PrintReceipt: {
      StartShift  : 'Έναρξη Βάρδιας',
      Delivery    : 'Παράδοση',
      Collection  : 'Παραλαβή',
      Canceled    : 'Ακυρωμένη',
      Cash        : 'Μετρητά',
      Card        : 'Κάρτα',
      WithoutStart: 'Χωρίς Έναρξη:',
      NotIncluded : 'Δεν Συμπεριλαμβάνονται',
      ByCard      : ' με Κάρτα ('
    },
    Notification: 'Η βάρδια στάλθηκε προς εκτύπωση!'
  },

  DeliveryStaffAddDialog: {
    Toolbar: {
      Color: 'indigo',
      Icon : 'directions_bike',
      Add  : {
        Title   : 'Προσθήκη Διανομέα',
        Subtitle: 'Δημιουργία Νέου Διανομέα'
      },
      Edit: {
        Title   : 'Επεξεργασία Διανομέα',
        Subtitle: 'Τροποποίηση Στοιχείων Διανομέα'
      }
    },
    Field: {
      Firstname: {
        Label: 'Όνομα',
        Hint : 'Όνομα διανομέα. πχ. Βαγγέλης, Μαρία, κλπ.',
        Icon : 'account_circle',
        Error: {
          Between: 'Το όνομα πρέπει να είναι από 2 έως 32 χαρακτήρες'
        }
      },
      Lastname: {
        Label: 'Επίθετο',
        Hint : 'Επίθετο διανομέα. πχ. Παπαδόπουλος, Μαρκορά, κλπ.',
        Icon : 'account_circle',
        Error: {
          Between: 'Το επίθετο πρέπει να είναι από 2 έως 32 χαρακτήρες'
        }
      },
      Telephone: {
        Label: 'Τηλέφωνο',
        Hint : 'Κινητό ή σταθερό τηλέφωνο διανομέα. πχ. 2106105200',
        Icon : 'phone',
        Error: {
          Between: 'Το τηλέφωνο πρέπει να είναι 8 έως 16 αριθμοί'
        }
      },
      Email: {
        Label: 'Email',
        Hint : 'Διεύθυνση Email διανομέα. πχ. support@getfoodpro.gr',
        Icon : 'email',
        Error: {
          Between: 'Το E-mail πρέπει να είναι έως 96 χαρακτήρες',
          Valid  : 'Το E-mail πρέπει να είναι έγκυρο'
        }
      },
      Notes: {
        Label: 'Σημειώσεις',
        Hint : 'Επιπλέον στοιχεία για τον διανομέα',
        Icon : 'speaker_notes'
      }
    }
  },

  DeliveryStaffDayShiftsDialog: {
    Header: {
      Icon : 'directions_bike',
      Title: 'Βάρδιες Ημέρας Διανομέα',
      Shift: 'Βάρδια'
    },
    Result: {
      NoOrders: {
        Icon    : 'shopping_cart',
        Color   : 'grey lighten-2',
        Title   : 'Δεν Υπάρχουν Παραγγελίες',
        Subtitle: 'Δεν υπάρχουν παραγγελίες στη βάρδια διανομέα'
      }
    }
  },

  SelectDeliveryStaffDialog: {
    Toolbar: {
      Icon    : 'directions_bike',
      Subtitle: 'Επιλογή Διανομέα'
    },
    Result: {
      NoDeliveryStaff: {
        Title   : 'Δεν Υπάρχουν Διανομείς',
        Subtitle: {
          Please       : 'Παρακαλώ',
          Open         : 'ανοίξτε',
          ShiftOr      : 'βάρδια ή',
          Create       : 'δημιουργήστε',
          DeliveryStaff: 'διανομέα'
        }
      }
    }
  },

  DeliveryStaffBarcode: {
    OnBarcodeScan: {
      Error: {
        Title: 'Barcode Παραγγελίας #',
        Body : 'Η παραγγελία δεν προστέθηκε! Παρακαλώ σαρώστε πρώτα το barcode διανομέα!'
      },
      SetActiveDeliveryStaff: {
        Add: {
          Body: 'Έναρξη παραλαβής παραγγελιών από διανομέα. Παρακαλώ σαρώστε barcode παραγγελίας.'
        },
        ClosedShift: {
          Title: 'Barcode Διανομέα',
          Body : 'Ο διανομέας {firstname} {lastname} δεν έχει ανοιχτή βάρδια. Παρακαλώ πρώτα ανοίξτε βάρδια.'
        },
        NotFound: {
          Title: 'Barcode Διανομέα',
          Body : 'Το barcode δεν αντιστοιχεί σε διανομέα!'
        }
      },
      ClearActiveDeliveryStaff: {
        Body: 'Λήξη παραλαβής παραγγελιών από διανομέα.'
      }
    }
  }
}
